module.exports = {
  "dof-popup": {
    "position": "fixed",
    "width": "750",
    "zIndex": 1000
  },
  "top": {
    "left": 0,
    "right": 0
  },
  "bottom": {
    "left": 0,
    "right": 0
  },
  "left": {
    "bottom": 0,
    "top": 0
  },
  "right": {
    "bottom": 0,
    "top": 0
  },
  "midea-actionsheet-bottom": {
    "height": "100",
    "flexDirection": "row",
    "justifyContent": "space-between"
  },
  "midea-actionsheet-btn": {
    "fontSize": "32",
    "color": "#232323",
    "backgroundColor": "#ffffff",
    "lineHeight": "100",
    "textAlign": "center",
    "flex": 1,
    "backgroundColor:active": "#f5f5f5"
  },
  "leftBtn": {
    "color": "#616C73",
    "borderRightColor": "#e5e5e5",
    "borderRightWidth": "1",
    "borderRightStyle": "solid"
  },
  "rightBtn": {
    "color": "#00A4F2"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-2193e31c!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-select-picker/index.vue
// module id = 446
// module chunks = 0 1